export default __webpack_public_path__ + "static/media/mic-btn-icon.7ec03de1.svg";